<template>
  <div class="common-problem common-animation">
    <div
      v-for="(item, index) in problemData"
      :key="index"
      class="question-border"
    >
      <div class="question-title" @click="rotate(index)">
        <div class="title-left" :style="{ '--titleLeftHover': titleLeftHover }">
          <img
            class="question-icon"
            :class="type == 2 ? 'otherStyle' : ''"
            :src="styleData.iconQuestion"
            alt=""
          />
          {{ item.title }}
        </div>
        <div class="title-right">
          <img
            :class="{ 'img-rotate': cur == index && showAnswer }"
            :src="styleData.iconDown"
            alt=""
          />
        </div>
      </div>
      <div
        class="question-answer"
        :class="{ 'show-answer': cur == index && showAnswer }"
        v-html="item.answer"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      value: {
        type: Number
      }
    },
    problemData: {
      value: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    titleLeftHover: {
      value: {
        type: String,
        default: ""
      }
    },

    styleData: {
      value: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    pageName: {
      value: {
        type: String,
        default: ""
      }
    }
  },
  data() {
    return {
      cur: 0,
      current: -1,
      showAnswer: true
    };
  },
  methods: {
    rotate(index) {
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.common-problem {
  margin: 0 auto;
  margin-top: 60px;
  padding: 32px 60px;
  width: 1200px;
  background: #fff;
  box-shadow: 0px 6px 18px 0px rgba(94, 123, 218, 0.08),
    0px 3px 6px -4px rgba(94, 123, 218, 0.12);
  border-radius: 12px;
  box-sizing: border-box;
}

.question-border {
  border-bottom: 1px solid #f2f3f5;
}

.question-border:last-child {
  border-bottom: none;
}

.question-title {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 72px;
  cursor: pointer;
  z-index: 5;

  .title-left {
    display: flex;
    align-items: center;
    .question-icon {
      margin-right: 16px;
      width: 24px;
      height: 24px;
    }
    .otherStyle {
      width: 22px;
      height: 21px;
    }
    font-size: 20px;
    line-height: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1d2129;
  }

  .title-right {
    width: 24px;
    height: 24px;

    img {
      width: 100%;
      height: 100%;
      transition: 0.5s ease all;
    }
    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }
  }
  &:hover {
    .title-left {
      color: var(--titleLeftHover);
    }
  }
}

.question-answer {
  position: relative;
  // display: none;
  margin: 0 auto;
  padding: 0px;
  width: 1000px;
  max-height: 0;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e5969;
  line-height: 24px;
  opacity: 0;
  transition: 0.3s ease all;
  z-index: 3;
}

.show-answer {
  padding: 6px 0px 16px 0px;
  // display: block;
  max-height: 200px;
  opacity: 1;
  transition: 0.4s ease all;
}

.problem-btn {
  margin: 0 auto;
  margin-top: 60px;
  width: 148px;
  height: 44px;
  background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
  border-radius: 4px;
  font-size: 16px;
  text-align: center;
  line-height: 44px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    background: linear-gradient(270deg, #2674ff 0%, #4eacff 100%);
  }
}
</style>
